<script>
import { mapGetters } from "vuex"

export default {
    name: 'ModalFooter',
    computed: {
        ...mapGetters({
            hasCircuits: "scripts/hasCircuits",
            hasSelectedCircuits: "scripts/hasSelectedCircuits",
            hasSelectedMoves: "scripts/hasSelectedMoves",
            hasMoreThanOneSelectedMoves: "scripts/hasMoreThanOneSelectedMoves",
            hasPendingMoves: "scripts/hasPendingMoves",
            isPreviousCircuitEmpty: "scripts/isPreviousCircuitEmpty",
        }),
        
        saving() {
            return this.$store.getters[`${this.currentType}/saving`];
        },
        allowCreateRound(){
            return this.hasCircuits && this.hasMoreThanOneSelectedMoves
        },
        statusLabel() {
            return this.saving ? 'Saving...' : 'Saved'
        },
        currentType() {
            const url = this.$route.path.split("/")[1];
            if (this.$route) {
                if (url == "update-warmup" || this.$route.path == "/create-warmup") {
                return "warmups";
                } else if (
                url == "update-stretch-flow" ||
                this.$route.path == "/create-stretch-flow"
                ) {
                return "stretchflows";
                }
            }
            return "workouts";
        },
         currentActivity() {
            return this.$store.getters[`${this.currentType}/currentActivity`];
        },
    },
    methods: {
        addCircuit(){
            this.$store.dispatch('scripts/addEmptyCircuit')
        },
        addMove(){
            this.$store.dispatch('scripts/addEmptyMoveToCurrentCircuit')
        },
        addInstruction(){
            this.$store.dispatch('scripts/addEmptyInstructionToCurrentCircuit')
        }, 
        makeRounds(){
            this.$store.dispatch('scripts/createRound')
        },
        addMoveAbove(){
            this.$store.dispatch('scripts/addMoveAboveCurrentCircuit')
        },
        addMoveBelow(){
            this.$store.dispatch('scripts/addMoveBelowCurrentCircuit')
        },
        addInstructionAbove(){
            this.$store.dispatch('scripts/addInstructionAboveCurrentCircuit')
        },
        addInstructionBelow(){
            this.$store.dispatch('scripts/addInstructionBelowCurrentCircuit')
        },   
        deleteSelectedMoves(){
            this.$store.dispatch('scripts/deleteSelectedItems')
        },
        deleteSelectedCircuits(){
            this.$store.dispatch('scripts/deleteSelectedCircuits',this.currentActivity.id)
        },
        moveItemsUp(){
            this.$store.dispatch('scripts/moveSelectedItemsUp')
        },
        moveItemsDown(){
            this.$store.dispatch('scripts/moveSelectedItemsDown')
        },
        moveItemsFirst(){
            this.$store.dispatch('scripts/moveSelectedItemsFirst')
        },
        moveItemsLast(){
            this.$store.dispatch('scripts/moveSelectedItemsLast')
        },        
    }
}

</script>

<style scoped>
  .icon-plus{
    font-size: 2.5rem;
    height: 2rem;
    position: relative;
    width: 48px;
  }
  .controls{
      display: flex;
      justify-content: center;
      width: calc(100% - 96px);
  }
  .controls .ctrl-btn{
      margin-right: 1rem;
      text-transform: uppercase;
  }
  .controls .ctrl-btn:last-child{
      margin-right: 0;
      text-transform: uppercase;
  }
  
  .ctrl-container{
      height: 2rem;
  }
  .icon-plus .b-icon.bi{
    vertical-align: text-top;
    position: absolute;
  }
  .status{
      width: 48px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
  }
  .dropdowns-wrapper{
      position: relative;
  }
  .controls--set{
      margin-right: 1rem;
  }
  .controls--set:last-child{
      margin-right: 0;
  }
  .saved{
      color: #469a2e;
  }
  .in-progress{
      color: gray;
  }
</style>
<template>
    <div class="w-100 row ctrl-container">
        <div class="icon-plus"><b-icon icon="plus"></b-icon></div>
        <div class="controls" v-if="!hasSelectedMoves && !hasSelectedCircuits">
            <b-button variant="primary" class="print-preview ctrl-btn" @click="addCircuit()" :disabled="hasPendingMoves || isPreviousCircuitEmpty">
                Add Circuit
            </b-button>
            <b-button variant="primary" class="add-move ctrl-btn" @click="addMove()" :disabled="!hasCircuits || hasPendingMoves">
                Add Move
            </b-button>
            <b-button variant="primary" class="add-instruction ctrl-btn" @click="addInstruction()" :disabled="!hasCircuits || hasPendingMoves">
                Add Instruction
            </b-button>
            <b-button variant="primary" class="make-round ctrl-btn" :disabled="!allowCreateRound" @click="makeRounds()">
                Make Round
            </b-button>
        </div>
        <div class="controls" v-if="hasSelectedMoves && !hasSelectedCircuits">
            <div class="controls--set">
                <b-button variant="outline-primary" :disabled="!hasSelectedMoves" @click="moveItemsFirst()" class="print-preview ctrl-btn">
                    <b-icon icon="chevron-double-up"></b-icon>
                </b-button>
                <b-button variant="outline-primary" :disabled="!hasSelectedMoves" @click="moveItemsUp()" class="print-preview ctrl-btn">
                    <b-icon icon="chevron-up"></b-icon>
                </b-button>
                <b-button variant="outline-primary" :disabled="!hasSelectedMoves" @click="moveItemsDown()" class="print-preview ctrl-btn">
                    <b-icon icon="chevron-down"></b-icon>
                </b-button>
                <b-button variant="outline-primary" :disabled="!hasSelectedMoves" @click="moveItemsLast()" class="add-move ctrl-btn">
                    <b-icon icon="chevron-double-down"></b-icon>
                </b-button>
            </div>
            <div class="dropdowns-wrapper controls--set" v-if="!hasMoreThanOneSelectedMoves">
                <b-dropdown id="dropdown-add-above" dropup text="ADD MOVE ABOVE" variant="primary" class="m-2" :disabled="hasPendingMoves">
                    <b-dropdown-item @click="addMoveAbove()">Add move above</b-dropdown-item>
                    <b-dropdown-item @click="addInstructionAbove()">Add an instruction</b-dropdown-item>
                </b-dropdown>
                <b-dropdown id="dropdown-add-below" text="ADD MOVE BELOW" variant="primary" class="m-2" :disabled="hasPendingMoves">
                    <b-dropdown-item @click="addMoveBelow()">Add move below</b-dropdown-item>
                    <b-dropdown-item @click="addInstructionBelow()">Add an instruction</b-dropdown-item>
                </b-dropdown>
            </div>
            <div class="controls--set">
                <b-button variant="primary" class="make-round ctrl-btn" :disabled="!allowCreateRound || hasPendingMoves" @click="makeRounds()">
                    Make Round
                </b-button>
                <b-button variant="danger" class="make-round ctrl-btn" @click="deleteSelectedMoves()" :disabled="hasPendingMoves">
                    <b-icon icon="trash"></b-icon>&nbsp;Delete Selection
                </b-button>
            </div>
        </div>
        <div class="controls" v-if="hasSelectedCircuits">
            <div class="controls--set">
                <b-button variant="danger" class="make-round ctrl-btn" @click="deleteSelectedCircuits()" :disabled="hasPendingMoves">
                    <b-icon icon="trash"></b-icon>&nbsp;Delete Circuits
                </b-button>
            </div>
        </div>
        <div class="status" :class="saving ? 'in-progress' : 'saved'">
            
           <span class="pr-1"><b-icon icon="check" aria-hidden="true" v-if="!saving" scale="1.3"></b-icon></span>
            {{statusLabel}}</div>
    </div>
</template>